import Header from '../components/header/header'
import { connect } from 'react-redux'
const mapStateToProps = (state) => {
    console.log("Header Container", state);
    return state.imageItems
}
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(Header)
